import React from 'react'
import { useSelector } from 'react-redux'
import InvalidSearchMessage from 'components/App/Pages/SearchPage/InvalidSearchMessage'
import Scroller from 'components/Scroller'
import SearchErrorMessage from 'components/App/Pages/SearchPage/SearchErrorMessage'
import DemoInboxCard from 'components/TrialSetup/DemoInboxCard'
import TicketList from 'subapps/ticketing/components/TicketList'
import { selectShowDemoInboxCard } from 'selectors/trial_setup'
import { selectPrefersShowTopNav } from 'selectors/app/selectAccountPreferences'
import { selectCurrentMailboxId } from 'selectors/mailboxes'
import { useMailboxAllTicketsCount } from 'ducks/searches/hooks'

import ActionBar from './ActionBar'
import SearchBar from './SearchBar'
import { styles } from './styles'

// Wraps the ticket list container and adds mouseEnter/Leave events
export default function TicketListPane({
  hasSearchErrored,
  isQueryStringValid,
  queryString,
}) {
  const showDemoInboxCard = useSelector(selectShowDemoInboxCard)
  const showTopNav = useSelector(selectPrefersShowTopNav)
  const currentMailboxId = useSelector(selectCurrentMailboxId)
  const hasAtLeastOneTicket = useMailboxAllTicketsCount(currentMailboxId) > 0

  return (
    <div css={[styles.base]}>
      {!showTopNav && <SearchBar />}

      {(hasAtLeastOneTicket || !currentMailboxId) && <ActionBar />}

      {queryString && hasSearchErrored && <SearchErrorMessage />}

      {queryString &&
        !isQueryStringValid &&
        !hasSearchErrored && (
          <Scroller className="desktopNormalScrollbarDisableRightBorder">
            <InvalidSearchMessage queryString={queryString} />
          </Scroller>
        )}
      {(!queryString || (!hasSearchErrored && isQueryStringValid)) && (
        <TicketList is3ColumnView isSidebarOpen />
      )}

      {showDemoInboxCard && <DemoInboxCard />}
    </div>
  )
}
